import React from 'react';
import { MenuItem as MuiMenuItem } from '@material-ui/core';

const MenuItem = props => <MuiMenuItem {...props} />;

export default MenuItem;
